/**
 * 欠席理由一覧
 */
export const ABSENCE_REASONS = ['私事都合', '病欠', '感染症', 'その他'] as const;

/** 欠席理由 */
export type AbsenceReasonType = typeof ABSENCE_REASONS[number];
